var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    'input-has-suffix': _vm.suffix
  }},[_c('input',_vm._g({staticClass:"input",class:{
      block: _vm.block,
      'input-with-suffix': _vm.suffix,
      'read-only': _vm.readOnly,
      'primary-border': _vm.primaryBorder,
      'red-border': _vm.redBorder || _vm.hasError
    },attrs:{"id":_vm.inputId,"disabled":_vm.disabled,"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"keyup":function($event){$event.stopPropagation();}}},{
      ..._vm.$listeners,
      input: event => _vm.setInput(event)
    })),(_vm.suffix)?_c('label',{staticClass:"suffix",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }